import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styles from './HorseAndJockeyImg.module.scss';
const HorseAndJockeyImg = ({ horseImg, jockeyImg }) => {
    return (_jsxs("div", Object.assign({ className: styles.element }, { children: [_jsx("img", { src: horseImg, className: styles.horse }), _jsx("img", { src: jockeyImg, className: styles.jockeyImg })] })));
};
export default HorseAndJockeyImg;
